module.exports = __webpack_public_path__ + "img/mainBannerBg-1.9d828320.jpeg";